import React, {useContext, useEffect, useState} from 'react';
import dayjs from "dayjs";
import GlobalContext from "../context/GlobalContext";

export default function Day({day,rowIdx}){


    function getCurrentDayClass() {
        return day.format("DD-MM-YYYY")===dayjs().format("DD-MM-YYYY")? "bg-green-600 text-white rounded-full w-7"
            :"";
    }

    const [dayEvents,setDayEvents] = useState([]);
    const{setDaySelected,setShowEventModal,savedEvents,setSelectedEvent}=useContext(GlobalContext);
    useEffect(()=>{
        console.log('SAVED EVENTS ::', savedEvents)
        const events = savedEvents?.filter(
            (evt)=>
                dayjs(evt.day).format("DD-MM-YY")===day.format("DD-MM-YY")
        );
        setDayEvents(events)
    },[savedEvents,day])

    return(

        <div className="border border-gray-200 flex flex-col">


            <header className="flex flex-col items-center">
                {rowIdx===0 && (
                    <p className="text-sm mt-1">{day.format('ddd').toUpperCase()}</p>
                )}
                <p className={`text-sm p-1 my-1 text-center ${getCurrentDayClass()}` }>{day.format('DD')}
                </p>
            </header>

            <div className="flex-1 cursor-pointer" onClick={()=>{
                console.log('CLICK EVENT :: DAY -> ', day)
                setDaySelected(day);
                setShowEventModal(true);
            }}>
                {dayEvents.map((evt,id)=>(
                    <div
                        className={`${evt.label} p-1 mr-3 text-gray-600 text-sm rounded mb-1 truncate`}
                        key={id}
                        onClick={()=> {
                            setSelectedEvent(evt)
                            console.log('CLICK EVENT :: EVENT -> ', day)
                        }}
                    >
                        <>{evt.title}</>
                        {/*<div>{evt.eventId}</div>*/}
                    </div>
                ))}
            </div>
        </div>
    );
}